var map = {
	"./InovazioneViticolturaCircleW250.png": 84953,
	"./InovazioneViticolturaW265.png": 56609,
	"./TecnicaDiColtivazioneCircleW250.png": 57388,
	"./TecnicaDiColtivazioneW265.png": 8736,
	"./UvaggioWd1200.png": 90475,
	"./UvaggioWd1600.png": 99535,
	"./UvaggioWd2000.png": 99420,
	"./UvaggioWd350.png": 35640,
	"./UvaggioWd3500.png": 81098,
	"./UvaggioWd500.png": 76505,
	"./UvaggioWd800.png": 16548,
	"./VitignoAutotocnoCococialaW265.png": 51543,
	"./VitignoCococialaCircleW250.png": 77879,
	"./VitignoImportatiCircleW200.png": 37837,
	"./VitignoImportatoW265.png": 98232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97751;